export function switchCase<K extends string | number | symbol, M extends Record<K, () => unknown>>(
	$case: K,
	match: M,
): ReturnType<M[K]> {
	return match[$case]() as ReturnType<M[K]>;
}
